import DataTable from 'datatables.net-react';
import { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import Swal from "sweetalert2";
import { JobServices } from '../../services/JobServices';
import * as BullCache from "../../util/BullCache";
import '../custom.css';

function Job() {

  const [loading, setLoading] = useState(false); 
  const [job, setJob] = useState([]);

  var user = BullCache.getFromCache("user");

  useEffect(() => {
    JobServices.getJobs({ "adminId": user.adminId })
      .then((resp) => {
        setLoading(false);

        if (resp.code === 1 && resp.data.jobList.length > 0) {
          setJob(resp.data.jobList);
        } else {
          setJob([]);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error('Error fetching jobs:', error);
      });
  }, [user.adminId]);


  const handlePlayClick = (event) => {
    const jobName = event.target.getAttribute("data-id");  // Get the job name
  
    // Call the API with jobName
    JobServices.runJobs({"jobName":jobName, "adminId": user.adminId})
      .then((response) => {
        if (response.code === 1) {
          Swal.fire({
            icon: "success",
            text: "Job started successfully!",
          });
          // Optionally, update the data table or do any other action
        } else {
          Swal.fire({
            icon: "error",
            text: "Failed to start the job!",
          });
        }
      })
      .catch((error) => {
        console.error("Error starting job:", error);
        Swal.fire({
          icon: "error",
          text: "Error occurred while starting the job.",
        });
      });
  };
  useEffect(() => {
    const handlePlayIconClick = (event) => {
      if (event.target.classList.contains("icon-play")) {
        handlePlayClick(event);
      }
    };
  
    document.addEventListener("click", handlePlayIconClick);
  
    return () => {
      document.removeEventListener("click", handlePlayIconClick);
    };
  }, []);
    
  const [columns, setColumns] = useState([
    { title: 'NO', data: 'no' },  // Use a custom 'no' field
    { title: 'JOB NAME', data: 'jobName' },
    { title: 'LAST START TIME', data: 'lastStartTime' },
    { title: 'LAST END TIME', data: 'lastEndTime' },
    { title: 'STATUS', data: 'status' },
    {
      title: "ACTION",
      render: (data, type, full, meta) => {
        return `
      <i class="me-3 fa fa-play icon-play" data-id="${full.jobName}" style="cursor: pointer"></i>
        `;
      },
    }
    
  ]);
  const jobWithNo = job.map((jobItem, index) => ({
    ...jobItem,
    no: index + 1  // Add a 'no' field starting from 1
  }));

  return (
    <Card>
      <Card.Body>
        <div className='table-responsive'>
          <DataTable 
            className="mt-1 table table-bordered bg-secondary-row fss-09 table th text-center"
            columns={columns}
            data={jobWithNo}  // Use the modified job list with the 'no' field
          />
        </div>
      </Card.Body>
    </Card>
  );
}

export default Job;
